import { tridionLabels } from '@/infrastructure/Configuration'
import { corporateService } from '@/infrastructure/Factory'

export default {
  async getLabels ({ commit }) {
    commit('loading')

    const { labels } = await window.labelsService.getLabels()
    global.corporateLabels = { ...tridionLabels, ...labels }

    commit('labelsLoaded', true)
    commit('free')
  },

  sendAnalyticsView () {
    const analyticsVariables = {}
    global.trackingService.appendViewData(analyticsVariables)
    global.trackingService.triggerAnalyticsEvent()
  },

  async getPressReleases ({ commit, state, dispatch, getters }, type) {
    commit('loading')

    const params = {
      offset: state.pagination.offset,
      limit: state.pagination.limit,
      topic: state.selectedTopic.key === 'allTopics' ? '' : state.selectedTopic.key,
      area: state.selectedArea.key === 'allAreas' ? '' : state.selectedArea.key,
      year: state.selectedYear.key === 'allYears' ? '' : state.selectedYear.key
    }

    const { pressReleases, filters, total, totalPages, offset } = await corporateService.getPressReleases(params)

    commit('setPressReleases', pressReleases)

    commit('updateFiltersDropdownOptions', {
      newFilters: filters,
      type,
      selectedFilters: getters.getSelectedFiltersNumber
    })
    commit('setPaginationTotal', Number(total))
    commit('setPaginationTotalPages', Number(totalPages))
    commit('setPaginationOffset', Number(offset))

    if (!pressReleases.length) {
      dispatch('setParamsErrorStatus', true)
    }

    commit('free')
  },

  async getTopics ({ commit }) {
    commit('loading')

    const data = await corporateService.getTopics()

    commit('setTopics', data.types)
    commit('setTopicDropdownOptions', data.types)
    commit('free')
  },

  async getAreas ({ commit }) {
    commit('loading')

    const data = await corporateService.getAreas()

    commit('setAreas', data.types)
    commit('setAreaDropdownOptions', data.types)
    commit('free')
  },

  async getFilters ({ commit, state }) {
    commit('loading')

    const params = {
      offset: state.pagination.offset,
      limit: state.pagination.limit,
      topic: '',
      area: '',
      year: ''
    }

    const data = await corporateService.getPressReleases(params)

    commit('setYears', data.filters.years)
    commit('setYearDropdownOptions', data.filters.years)
    commit('setFilters', data.filters)
    commit('free')
  },
  async setParamsErrorStatus ({ commit }, data) {
    commit('loading')
    commit('setQueryParamError', data)
    commit('free')
  }
}
